import { Delta } from "json-difference";

export const logAddedFields = (addedFields: Delta["added"]) => {
  if (addedFields.length > 5) {
    console.log(
      "\x1B[1mAdded fields:\x1B[m",
      addedFields.map(([path, value]) => ({
        path,
        value,
      })),
    );
  } else {
    addedFields.forEach(([path, value]) => {
      console.log(`\x1B[1mAdded field ${path} with value:\x1B[m`, value);
    });
  }
};
